import { useFormik } from 'formik'
import { useRouter } from 'next/router'
import {
  mapAccessApproveSchema,
  MapstackLoadingBackdrop,
  MapAccessApprove as View
} from 'ui-components'
import { useAuth } from 'user-auth'
import { getUserLink, getWorkspaceLink } from 'utils'

import { useCreateMapAccess } from '~map-access/queries/useCreateMapAccess'
import { useGetMapByIdForPublic } from '~map-access/queries/useGetMapByIdForPublic'
import { useGetUserById } from '~map-access/queries/useGetUserById'

export function MapAccessApprove() {
  const router = useRouter()
  const { user } = useAuth()
  const { data: requestUser } = useGetUserById()
  const { data: map } = useGetMapByIdForPublic()
  const { mutateAsync, isPending } = useCreateMapAccess()

  const form = useFormik({
    validationSchema: mapAccessApproveSchema,
    initialValues: {
      role: 'member'
    },
    onSubmit: async (values) => {
      if (!map) throw Error('MapNotFound')

      await mutateAsync({ role: values.role })
      router.push(
        getWorkspaceLink({
          workspaceId: map?.workspace?.id,
          workspaceName: map?.workspace?.name
        })
      )
    }
  })

  const handleDenyClick = () => {
    if (!user) return

    router.push(
      getUserLink({
        userId: user.id,
        firstName: user.firstName as string,
        lastName: user.lastName as string
      })
    )
  }

  if (!requestUser && !map) return <MapstackLoadingBackdrop />

  return (
    <View
      form={form}
      user={requestUser}
      map={map}
      slotProps={{
        SubmitButton: {
          loading: isPending
        },
        DenyButton: {
          loading: isPending,
          onClick: handleDenyClick
        }
      }}
    />
  )
}
